import { SelfDto } from "@repo/api/user";

const LATEST_TEAM_EXTERNAL_ID_KEY = "latestTeamExternalId";

export function getLatestTeamExternalId(
  memberships: SelfDto["teamMemberships"],
) {
  const membeshipIds = memberships.map(
    (membership) => membership.teamExternalId,
  );

  if (membeshipIds.length === 0) {
    return null;
  }

  let latestTeamExternalId = localStorage.getItem(LATEST_TEAM_EXTERNAL_ID_KEY);

  if (latestTeamExternalId && membeshipIds.includes(latestTeamExternalId)) {
    return latestTeamExternalId;
  }

  latestTeamExternalId = membeshipIds[0]!;

  return latestTeamExternalId;
}

export function setLatestTeamExternalId(teamExternalId: string) {
  localStorage.setItem(LATEST_TEAM_EXTERNAL_ID_KEY, teamExternalId);
}
